<template>
  <div class="card contact-card sticky-lg-top">
    <div class="card-body text-center">
      <h3>Neem contact op</h3>

      <p class="mt-1 text-black small">
        Heeft u interesse in een van onze panden of wilt u meer informatie? Neem
        gerust contact met ons op via onderstaande gegevens.
      </p>

      <div class="text-black my-3">
        <p class="m-0">
          <strong>E-mail:</strong>
          <a
            href="mailto:info@koemansvastgoed.nl"
            class="text-decoration-none text-primary"
          >
            info@koemansvastgoed.nl
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookNowComponent", // of ContactCard, pas aan naar wens
};
</script>

<style scoped>
.contact-card {
  border: none;
  top: 0;
}

@media (min-width: 992px) {
  .contact-card {
    top: 140px !important;
  }
}
</style>
